module.exports = __webpack_public_path__ + "img/enter_car_details.46935d65.svg";